module.exports = __webpack_public_path__ + "img/department-line.cd465e9d.svg";